<style scoped>
  template { margin:auto;}
  h2, h4, p { text-align:center; }
  th {background-color: #eeeeee; text-align:left;}
  th.title { text-align:center; }
  .container { width:50%; margin: auto; float:left; margin-bottom: 20px; }
  table { width:100%; }
  table tr td, table tr th { border: 1px solid; }
  .spacer {padding: 15px;}
  #customerLabel { margin-bottom: 40px; }
  #patientCopy { margin-bottom: 40px; }
  .barcode-font {height: 90px}
  @media print {
    * {font-size:10px;}
    #customerLabel { margin-bottom: 35px; }
    #patientCopy { margin-bottom: 35px; }
    .spacer {padding: 1px;}
    template { margin: 0px; padding: 0px;}
    #btnPrint { display:none; }
    h2, h4, p { font-size:12px; }
    @page { size: landscape; }
    .barcode-font {height: 70px}
  }
</style>
<template>
  <div class="container-fluid" v-if="isLoaded">
    <div> <input type="button" id="btnPrint" onclick="javascript: window.print()" value="Print" /> </div>
    <div class="container">
      <div>
        <h2>Exam Summary</h2>
      </div>
      <div>
        <h4>Participant Copy</h4>
      </div>
      <div id="customerLabel">
        <p>Keep this half for your records.</p>
      </div>
      <div>
        <table>
          <tbody>
          <tr>
            <th colspan="2" class="title">Exam Information</th>
          </tr>
          <tr>
            <th>Patient Name:</th>
            <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
          </tr>
          <tr>
            <th>Examining Doctor:</th>
            <td>{{doctor.lastName}}, {{doctor.firstName}}</td>
          </tr>
          <tr>
            <th>Submitted Date:</th>
            <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
          </tr>
          <tr>
            <th>Participant:</th>
            <td>{{Account.accountType == 1 ? Account.primaryContact.firstName + ' ' + Account.primaryContact.lastName + ' ' + Account.primaryContact.suffix : Account.primaryContact.legalName }}</td>
          </tr>
          <tr>
            <th>Participant Phone:</th>
            <td>{{Account.primaryContact.phoneNumber | phone_format}}</td>
          </tr>
          <tr>
            <th>Participant Email</th>
            <td>{{Account.emailAddress}}</td>
          </tr>
          <tr>
            <th>Entry ID:</th>
            <td>{{Order.id}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="spacer"></div>
      <div>
        <table>
          <tbody>
          <tr>
            <th>This document is intended only for record keeping purposes and indicates that an exam was performed but no glasses were prescribed unless otherwise indicated below.</th>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="spacer"></div>
      <div>
        <table>
          <tbody>
          <tr>
            <th>Patient/Exam Notes</th>
          </tr>
          <tr>
            <td>{{Order.dispenserNotes}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container">
      <div>
        <h2>Exam Summary</h2>
      </div>
      <div>
        <h4>Patient Copy</h4>
      </div>
      <div id="patientCopy">
        <p>Keep this half for your records.</p>
      </div>
      <div>
        <table>
          <tbody>
          <tr>
            <th colspan="2" class="title">Exam Information</th>
          </tr>
          <tr>
            <th>Patient Name:</th>
            <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
          </tr>
          <tr>
            <th>Examining Doctor:</th>
            <td>{{doctor.lastName}}, {{doctor.firstName}}</td>
          </tr>
          <tr>
            <th>Submitted Date:</th>
            <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
          </tr>
          <tr>
            <th>Participant:</th>
            <td>{{Account.accountType == 1 ? Account.primaryContact.firstName + ' ' + Account.primaryContact.lastName + ' ' + Account.primaryContact.suffix : Account.primaryContact.legalName }}</td>
          </tr>
          <tr>
            <th>Participant Phone:</th>
            <td>{{Account.primaryContact.phoneNumber | phone_format}}</td>
          </tr>
          <tr>
            <th>Participant Email</th>
            <td>{{Account.emailAddress}}</td>
          </tr>
          <tr>
            <th>Entry ID:</th>
            <td>{{Order.id}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="spacer"></div>
      <div>
        <table>
          <tbody>
          <tr>
            <th>This document is intended only for record keeping purposes and indicates that an exam was performed but no glasses were prescribed unless otherwise indicated below.</th>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="spacer"></div>
      <div>
        <table>
          <tbody>
          <tr>
            <th>Patient/Exam Notes</th>
          </tr>
          <tr>
            <td>{{Order.dispenserNotes}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  function InitialData(orderId)
  {
    return {
      Order: {},
      Account: {},
      isLoaded: false,
    }
  }
  import HeaderComponent from "@/components/shared/HeaderComponent";
  import FooterComponent from "@/components/shared/FooterComponent";
  import VueBarcode from '@xkeshi/vue-barcode';
  export default {
    components: {HeaderComponent, FooterComponent, VueBarcode},
    data(){
      return InitialData();
    },
    mounted:function(){
      this.GetOrderById(this.$route.query.orderId) //method1 will execute at pageload
    },
    methods: {
      GetOrderById(orderId){
        var _this = this;

        axios.get('/Order/GetOrderAccount/' +  orderId, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}}).then(function (response) {
          _this.Order = response.data.raw.order;
          _this.Account = response.data.raw.account;

          axios.post('/Account/EyeDoctor/GetEyeDoctor/' +  _this.Order.eyeDoctorId, _this.Account)
            .then(function (response) {
              if(response.data.isSuccess == true){
                _this.Account.eyeDoctors = response.data.raw;
                _this.doctor = _this.Account.eyeDoctors.filter(a => a.salesforceId == _this.Order.eyeDoctorId)[0];
                _this.isLoaded = true;
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ExamSummary.vue?5888b8a8